<template lang="functional"></template>

<script>
/**
 * Who i am?    Волшебник
 * What i do?   Обёртка вокруг frame для работы в разных ВУЯХ
 * */

import cfg from '../../config';

export default {
  name: 'Wizard',
  props: {
    debug: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    frame: null,
    src: '',
    id: 'wizard-guru',
    flag: '*',
    cb: null,
    cityCb: null,
  }),
  beforeDestroy() {
    window.removeEventListener('message', this.router, false);
    document.body.removeChild(this.frame);
  },
  deactivated() {
    window.removeEventListener('message', this.router, false);
    document.body.removeChild(this.frame);
  },
  mounted() {
    this.src = cfg.getWizard(window.location.hostname);
    // create frame
    const frame = document.createElement('iframe');
    frame.setAttribute('src', this.src);
    frame.setAttribute('id', this.id);
    frame.style.width = '0';
    frame.style.height = '0';
    document.body.appendChild(frame);

    window.addEventListener('message', this.router, false);
    this.frame = document.querySelector(`#${this.id}`);

    this.$root.wizard = {
      login: this.login,
      logout: this.logout,
      isLogin: this.isLogin,
      isCity: this.isCity,
      city: this.city,
    };
    if (this.debug) {
      global.console.warn('Wizard in debug mode');
      window.wizard = this.$root.wizard;
      global.console.info('We installed wizard in window >>>', window.wizard);
    }
  },
  methods: {
    router(event) { // private method
      if (this.debug) {
        global.console.info('event from frame', event);
        global.console.info('data from frame', event.data);
      }
      // For Chrome, the origin property is in the event.originalEvent object.
      // const origin = event.origin || event.originalEvent.origin;

      if (typeof event.data === 'object' && event.data.action && event.data.action === 'isLogin' &&
      this.cb) {
        this.cb(event.data.data);
        this.cb = null;
      }
      if (typeof event.data === 'object' && event.data.action && event.data.action === 'isCity' &&
      this.cityCb) {
        this.cityCb(event.data.data);
        this.cityCb = null;
      }
    },
    send(func, data) { // private method
      if (this.debug) {
        global.console.info('data send in frame', data || 'empty');
      }
      this.frame.contentWindow.postMessage({
        call: func,
        value: data,
      }, this.flag);
    },

    login(token, avatar, username) {
      this.send('login', {
        token,
        avatar,
        username,
      });
    },
    logout() {
      this.send('logout');
    },
    city(city) {
      global.console.log('setting city', city);
      this.send('city', city);
    },
    /**
     * @returns {*} in callback false or object with data { token, avatar, region, username }
     */
    isLogin(callback) {
      if (this.debug) {
        global.console.info('isLogin called');
      }
      this.cb = callback;
      this.send('isLogin');
    },
    isCity(callback) {
      if (this.debug) {
        global.console.info('isCity called');
      }
      this.cityCb = callback;
      this.send('isCity');
    },
  },
};
</script>
